import { NgModule } from '@angular/core';
import { ButtonComponent } from './button.component';
import { CommonModule } from '@angular/common';
import { IconComponentModule } from '../icon/icon-component.module';

@NgModule({
    imports: [
        CommonModule,
        IconComponentModule
    ],
    declarations: [
        ButtonComponent
    ],
    exports: [
        ButtonComponent
    ]
})
export class ButtonComponentModule {}
